import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import { deleteTier, getTierList } from 'app/api/tier';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import { formatToIndianRupee, ParseTableLabelDate } from 'app/utils/Parsers';
const useTierManagement = () => {
  const [isdeleteFiltering, setIsdeleteFiltering] = useState(false); // New state to track filtering
  const navigate = useNavigate();
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [data, setData] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [pageLoading, setPageLoading] = useState(false);
  const currentPage = 1;
  const dataPerPage = 10;
  const [filteredData, setFilteredData] = useState([]);
  const [totalNumber, setTotalNumber] = useState(0);
  const [isFiltering, setIsFiltering] = useState(false);

  const sectionObj = {
    sectionTitle: 'Tier Mangement',
    searchObj: {
      keys: ['name', 'mallName'],
      placeholder: 'Search Name , Mall name',
      searchType: 'server',
      handleSearch: (e) => {
        console.log('Handle search: ', e);
      },
    },
    buttons: [
      {
        customclassName: 'bg-white margin-right-class',
        imgTrue: false,
        title: 'Filter',
        handleBtnClick: (e) => {
          setIsFilterOpen(!isFilterOpen);
        },
      },
      {
        customclassName: 'black-btn margin-right-class',
        imgTrue: true,
        title: APP_CONSTANTS.CREATE_DEFAULT_TIER_TAG,
        handleBtnClick: (e) => {
          navigate(`${APP_CONSTANTS.CREATE_DEFAULT_TIER}`);
        },
      },
      {
        customclassName: '',
        imgTrue: true,
        title: 'Add Festive',
        handleBtnClick: (e) => {
          navigate(`${APP_CONSTANTS.CREATE_FESTIVE_TIER}`);
        },
      },
    ],
  };
  const [values, setValues] = useState({
    startDate: '',
    endDate: '',
    tiername: '',
  });

  const fetchTierData = useCallback(
    async (page, search = '', filter = {}) => {
      setPageLoading(true);
      try {
        let requestParam = {
          page,
          limit: dataPerPage,
          search,
          tiername: filter.tiername,
          startDate: filter.startDate,
          endDate: filter.endDate,
        };
        const response = await getTierList(requestParam);
        if (response?.responseCode === 200) {
          const dataArr = response?.data?.data || [];

          const newArray = dataArr?.map((item) => ({
            ...item,
            range: `${
              item?.minRange ? formatToIndianRupee(item?.minRange) : ''
            }-${item?.maxRange ? formatToIndianRupee(item?.maxRange) : ''}`,
            startDate: item?.startDate ? ParseTableLabelDate(item?.startDate) : '',
            endDate: item?.endDate ? ParseTableLabelDate(item?.endDate) : '',
            parentName: item?.parentName,
            mallName: item?.mallName,
            name: item?.name,
          }));
          setData(newArray);
          setFilteredData(newArray);
          const totalCount = response?.data?.count || 0;
          const tempcount = Math.ceil(totalCount / dataPerPage);
          setTotalNumber(totalCount);
          setPageCount(tempcount);
          setIsdeleteFiltering(false);
        } else {
          Toast.error(
            response?.response?.message || Message.Error.COMMON_MESSAGE
          );
        }
      } catch (error) {
        Toast.error(Message.Error.COMMON_MESSAGE);
      } finally {
        setPageLoading(false);
      }
    },
    [dataPerPage]
  );

  function handleDelete(data) {
    confirmAlert({
      title: '',
      message: `Are you sure you want to delete ${data?.name} this
Tier?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            calldeleteTier(data);
          },
        },
        {
          label: 'No',
        },
      ],
      overlayClassName: 'overlay-custom-class-name',
    });
  }
  async function calldeleteTier(data) {
    setPageLoading(true);
    if (data && data?.id) {
      let responseObj = await deleteTier(data?.id, data?.tierType);
      setPageLoading(false);
      if (responseObj?.responseCode === 200) {
        setIsdeleteFiltering(true);
        Toast.success('Tier Deleted Successfully');
      } else {
        Toast.error(
          responseObj?.response?.message
            ? responseObj?.response?.message
            : Message.Error.COMMON_MESSAGE
        );
      }
    }
  }

  function handleEdit(data) {
    if (data.tierType === 'festive') {
      navigate(`/festive-tier/edit/:${data.id}`, {
        state: {
          ...data,
        },
      });
    } else {
      navigate(`/default-tier/edit/:${data.id}`, {
        state: {
          ...data,
        },
      });
    }
  }

  function handleFiltering() {
    const filtered = data.filter((item) => {
      let isInvoiceDateStartMatching =
        !values.startDate ||
        new Date(item?.startDate) >= new Date(values.startDate);

      let isInvoiceDateEndMatching =
        !values.endDate || new Date(item?.endDate) <= new Date(values.endDate);

      const isNameMatching =
        !values?.tiername ||
        item?.name?.toLowerCase().includes(values?.tiername.toLowerCase());

      return (
        isInvoiceDateStartMatching && isInvoiceDateEndMatching && isNameMatching
      );
    });

    setFilteredData(filtered);
  }
  function resetfilter() {
    setValues({
      startDate: '',
      endDate: '',
      tiername: '',
    });
    fetchTierData(1);
  }
  function onCancel() {
    setIsFilterOpen(false);
  }
  useEffect(() => {
    if (isFiltering) {
      handleFiltering();
      setIsFiltering(false);
    }
  }, [isFilterOpen, isFiltering, data, values, filteredData]);

  function onSubmit(event) {
    event.preventDefault();
    setIsFiltering(true);
  }
  return {
    handleDelete,
    values,
    setValues,
    pageLoading,
    data,
    fetchTierData,
    currentPage,
    dataPerPage,
    totalNumber,
    pageCount,
    navigate,
    handleEdit,
    isFilterOpen,
    setIsFilterOpen,
    sectionObj,
    filteredData,
    resetfilter,
    onCancel,
    onSubmit,
    isFiltering,
    isdeleteFiltering,
  };
};

export default useTierManagement;
